import React from "react";
import { Logo, tutorIcons } from "../../assets";
import { Forms } from "../../components";

const Login = () => {
  return (
    <section className="px-5 font-inter max-w-[428px] flex justify-center">
      <div className="flex flex-col items-center justify-center">
        <div className="mt-12">
          <img src={Logo} alt="Logo"/>
          <p className="mt-5 text-gray-lightGray text-15px">TutorChat</p>
        </div>
        <div className="flex justify-between w-full my-16">
            <div className="">
                <h3 className="text-xl font-medium">Login Account</h3>
                <p className="text-15px text-gray-lightGray mt-4">Hello, Welcome back to your account.</p>
            </div>
            <div className="">{tutorIcons.userAvatar}</div>
        </div>
        <Forms />
      </div>
    </section>
  );
};

export default Login;
